<ion-content>
  <div class="constrained-content">
    <div>
      <div class="flex-space-between" style="padding: 15px 5px 0 3px">
        <div class="button-container flexed-align-center">
          <ion-searchbar
            mode="ios"
            placeholder="Search tags..."
            showCancelButton="never"
            [(ngModel)]="searchText"
            (ionChange)="handleFilters()"
            class="rounded-search-bar"
          >
          </ion-searchbar>
        </div>

        <div class="button-container flexed-align-center">
          <ion-button (click)="createTag()">
            <ion-icon name="add-outline"></ion-icon>
            <span class="text-with-left-icon hidden-sm"> Create tag </span>
          </ion-button>
        </div>
      </div>
    </div>
    <ion-card class="outline-card" style="margin: 18px">
      <ngx-datatable
        class="material"
        columnMode="force"
        [limit]="100"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="50"
        [scrollbarH]="true"
        [rows]="filteredTags"
        [reorderable]="true"
      >
        <ngx-datatable-column name="Name" prop="name" [minWidth]="140">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <a class="row-title row-link" (click)="editTag(row.id)">{{ value }}</a>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Project" prop="projectId" [minWidth]="300" *ngIf="!authService.selectedProject">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ row.project ? row.project.name : 'All projects' }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="" prop="id" [sortable]="false" [minWidth]="90">
          <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <ion-button fill="clear" class="btn-small" (click)="viewConversationsForTag(row)">
              View in inbox</ion-button
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Description" prop="description" [minWidth]="300">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ value }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          *ngIf="authService.tenant.aiFeatures?.autoTagging"
          name="AI Tagging Enabled"
          prop="autoTaggingEnabled"
          [minWidth]="180"
          [sortable]="false"
        >
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <label class="switch">
              <input type="checkbox" [checked]="value" (click)="toggleAutoTagging(row)" />
              <span class="slider"></span>
            </label>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Created at" prop="createdAt" [minWidth]="100">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ value | date: 'M/d/yyyy' }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </ion-card>
  </div>
</ion-content>
